<template>
  <EntityCustomFields :entity="CustomFieldEntity.Student" :entityId="studentId" :canEdit="canEdit" />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { CustomFieldEntity } from '@/types/composition-functions';
import { useUserStore } from '@/store/userStore';
import { AppPermissions, can } from '@/utils/permissions';
import EntityCustomFields from '@/components/common/EntityCustomFields.vue';

/** The school's student custom fields on a student profile (#574). Editing needs Students → Update. */
defineProps<{ studentId: string | number }>();

const userStore = useUserStore();
const canEdit = computed(() =>
  can(userStore.currentUser, AppPermissions.Students.Actions.Update, AppPermissions.Students.Resource),
);
</script>
